export const isStringArray = (value: string | string[]): value is string[] =>
  Array.isArray(value)
